import theme from '@app/ui/theme'
import styled from 'styled-components'

interface EvalSideBarTabItemProps {
  sideBarCollapsed?: boolean
}
const isPhone = window.innerWidth <= 767

export const EvalSideBarTabItem = styled.div<EvalSideBarTabItemProps>`
  height: 39px;
  border-bottom: 1px solid ${theme.colors.light};
  background-color: ${theme.colors.white};
  z-index: 1;
  & a {
    cursor: pointer;
    white-space: nowrap;
    background-color: ${theme.colors.white};
    color: #333;
    display: block;
    line-height: 40px;
    padding-left: 20px;
    padding-right: 10px;
    height: 100%;
    font-size: 16px;
    font-weight: 460;
    text-wrap: no-wrap;
    letter-spacing: 0px;
  }

  &:hover a {
  }

  &.active a {
    background-color: ${theme.colors.primary};
    color: ${theme.colors.white};
  }
`

export const MobileEvalSideBarTabItem = styled.div<EvalSideBarTabItemProps>`
  height: ${!isPhone ? '40px' : '20px'};
  border-bottom: ${!isPhone ? '1px' : '0.5px'} solid ${theme.colors.light};
  z-index: 1;
  & a {
    cursor: pointer;
    white-space: nowrap;
    background-color: ${theme.colors.white};
    color: #333;
    display: block;
    line-height: ${!isPhone ? '40px' : '20px'};
    padding-left: ${!isPhone ? '20px' : '10px'};
    padding-right: ${!isPhone ? '10px' : '5px'};
    height: 100%;
    font-size: ${!isPhone ? '16px' : '9px'};
    font-weight: ${!isPhone ? 400 : 240};
    text-wrap: no-wrap;
    letter-spacing: 0px;
  }

  &:hover a {
  }

  &.active a {
    background-color: ${theme.colors.primary};
    color: ${theme.colors.white};
  }
  width: '100%';
`
